module.exports = __webpack_public_path__ + "static/media/offerte.29cfa477.svg";